const ProductSliderSkeleton = () => {
  return <div className="animate-pulse py-10" data-sentry-component="ProductSliderSkeleton" data-sentry-source-file="ProductSliderSkeleton.jsx">
      <div className="flex items-center py-4 text-2xl">
        <div className="h-6 w-48 rounded bg-gray-300"></div>
        <div className="ms-auto">
          <div className="grid grid-cols-2 gap-2">
            <div className="size-8 rounded-full bg-gray-300"></div>
            <div className="size-8 rounded-full bg-gray-300"></div>
          </div>
        </div>
      </div>
      <div className="m-auto max-w-full">
        <div className="overflow-hidden">
          <div className="ml-[calc(1rem*_-1)] flex touch-pan-y touch-pinch-zoom flex-wrap">
            {[...Array(4)].map((_, index) => <div className="[min-width:1200px]:flex-[0_0_1.5rem] [min-width:1200px]:pl-6 [max-width:749px]:flex-[0_0_var(calc(100%/2.3))] [max-width:749px]:pl-2 w-1/2 min-w-0 flex-[0_0_100%] p-2 pl-4 sm:flex-[0_0_50%] sm:pl-4" key={index}>
                <div className="flex flex-col">
                  <div className="mb-4 h-40 rounded bg-gray-300"></div>
                  <div className="mb-2 h-4 rounded bg-gray-300"></div>
                  <div className="mb-2 h-4 rounded bg-gray-300"></div>
                  <div className="h-6 w-1/2 rounded bg-gray-300"></div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};
export default ProductSliderSkeleton;